export enum GeneralLedgerExportTypes {
  CSV,
  IIF,
  QBO
}

export enum GeneralLedgerExportFrequencies {
  DateRange,
  Payroll,
  MTD,
  QTD,
  YTD
}

export enum GeneralLedgerDownloadTypes {
  Checks,
  Totals
}

export enum ApprovalTypes {
  Manual,
  Automatic,
  Approval
}

export interface GLConfiguration {
  Username: string;
  Obsolete: boolean;
  ClientCode: string;
  ColOrder: any[];
  ConfigId: number;
  ConnectedToQBO: boolean;
  CreateNewClasses: boolean;
  ExportFileType: GeneralLedgerExportTypes;
  FromDate: Date;
  GLAccount: string;
  Id: number;
  Name: string;
  Offset: string;
  SubmissionType: ApprovalTypes;
  TimeFrame: GeneralLedgerExportFrequencies;
  ToDate: Date;
  Type: GeneralLedgerDownloadTypes;
  UseClasses: boolean;
}

export interface QboCredentialRequirements {
  Code: string;
  RealmId: string;
  State: string;
}

export interface GlTotalsData {
  Amount: number;
  Class: string;
  ConfigId: string;
  Date: string;
  GLAccount: string;
  Memo: string;
  Type: string;
}

export interface GlCheckData {
  Check: string;
  Date: string;
  GLAccount: string;
  NetPay: 0;
  OffsetAccount: string;
  Payee: string;
}

export interface GLConfigCategory {
  Code: string;
  Display: string;
  DivisionChildren: any;
  Id: number;
  Parent: string | null;
  Position: number;
  Children: GLConfigCategory[];
}

export enum GLMappingLevelEnum {
  COMPANY,
  DIVISION,
  DEPARTMENT,
  DIVISION_AND_DEPARTMENT,
  JOB_CODE,
  NOT_EXPORTED
}

export interface GlMappingGroup {
  Category: number;
  ConfigurationId: number;
  Id: number;
  Level: GLMappingLevelEnum;
  Rows: GlMappingRow[];
}

export interface GlMappingRow {
  CheckName: string | null;
  CheckNumber: string | null;
  DepartmentNumber: number | null;
  DivisionNumber: number | null;
  GlAccount: string;
  GlAccountID: number;
  GlClassID: number;
  GlClass: string;
  GroupId: number;
  Id: number;
  IsDebit: boolean;
  IsDefault: boolean;
  IsOffset: boolean;
  JobCode: number;
  NotExported: boolean;
  TypeName: string;
}

export interface GlExportHistory {
  ConfigId: number;
  ConfigName: string;
  ExportFileType: GeneralLedgerExportTypes;
  Created: string | Date;
  Error: string;
  Id: number;
  Status: string;
  Username: string;
}

export enum GLCategories {
  EARNINGS, //0
  DEDUCTIONS, //1
  EMPLOYEE_TAXES, //2
  EMPLOYER_TAXES, // 3
  DISBURSEMENTS, //4
  SERVICE_BUREAU_DEBITS, //5
  EMPLOYER_TAX_OFFSET, //6
  EMPLOYER_CONTRIBUTIONS_OFFSET, //7
  COVID_CREDITS, //8
  PAYMENTS, //9
  EMPLOYER_CONTRIBUTIONS, //10
  SERVICE_BUREAU_INVOICE //11
}

export interface GlDivision {
  Code: string;
  Display: string;
  Id: number;
  Parent: string;
  Position: number;
  DivisionChildren: GlDivision[] | null;
}

export interface GlQboAccount {
  Name: string;
  FullyQualifiedName: string;
  Id: string;
}
